import ItemPermissionView from "./ItemPermissionView";
import { useStore } from 'react-redux';
import G from './Getters';

export default function PermissionTable(){
  let store = useStore();
  let state = store.getState();

  let { data } = state;

  const actions = ["read","write","archive"]

  let rows = Object.entries(data).filter(x => Object.keys(x[1]).length > 0).map(([itemType,itemCol],ii) => {

    if( ii > 5 ){
      return null;
    }
    

    return Object.entries(itemCol).map(([itemId,item],jj) => {

      //if( jj > 0 ){ return null; }

      let actionPermissions = actions.map(action => (
        <td class="small-margin">
          <ItemPermissionView {...{ itemType, itemId, action } }/>
        </td>
      ))

      const meta = G.getMeta(state,{itemType,_id:itemId})
      const owner = Object.entries(meta.permissions||{}).find(x => x[1]==="OWNER")?.[0]


      return (
        <tr>
          <td class="fair-padding">{owner}</td>
          <td class="fair-padding">{itemType}</td>
          <td class="small-padding">{itemId}</td>
          {actionPermissions}
        </tr>

      )


    })

  })

  return (
    <div class="full-dim" style={{
      minHeight:0,
      overflow:'scroll',
    }}>
    <table>
      {rows}
    </table>
    </div>
  )






}
